<template>
 <main class="dn-margin-1">
    <div id="homePage">

      <ProductCard
        v-for="product in products"
        :key="product.id"
        :title="product.title"
        :image="product.image"
        @click="openPage(product.id)"
      />

    </div>
  </main>
</template>

<script>
import ProductCard from './ProductCard.vue'
import { getProductsByCategory } from '@/config/products'

export default {
  name: 'dualLens',
  components: {
    ProductCard
  },
  data () {
    return {
      products: []
    }
  },
  created() {
    // const type = this.$route.query.type || 'standard'
    // this.products = getProductsByCategory('washing')
    this.products = getProductsByCategory('dwm')
  },
  mounted(){
    this.hideFooter();
  },
  methods: {
    openPage: function (page) {
      let qdParam = this.$route.query.qd || this.$route.query.q || ''
      this.$parent.$router.push('/xxxz?toPage=' + page + '&qd=' + qdParam)
    },
    hideFooter() {
      const footer = document.querySelector('.dn-footer');
      // const nav = document.querySelector('.dn-nav')
      // if (footer) {
      //   footer.style.display = 'none';
      // }
      // if (nav) {
      //   nav.style.display = 'none';
      // }
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/dualLens.vue